import TraitsCard from './TraitsCard';
export default TraitsCard;
